module.exports = __webpack_public_path__ + "static/media/image.a5e952a5.svg";